export const MOCK_ORG_TREE = [
  {
    id: "org-1",
    name: "2423Acme Inc.",
    unitLevel: "parent",
    location: "Singapore",
    children: [
      {
        id: "org-2",
        name: "North Region",
        unitLevel: "level_1",
        location: "Singapore",
        children: [
          {
            id: "org-3",
            name: "Manufacturing",
            unitLevel: "level_2",
            location: "Singapore",
            children: [],
          },
        ],
      },
      {
        id: "org-4",
        name: "International",
        unitLevel: "level_1",
        location: "Malaysia",
        children: [],
      },
    ],
  },
];

export const MOCK_REPORTS = [
  {
    id: "report-001",
    name: "FY2025 ESG Report",
    framework: "SGX",
    status: "completed",
    orgId: "org-1",
    reportYear: 2025,
    reportingPeriod: {
      start: "2025-01-01",
      end: "2025-12-31",
    },
  },
  {
    id: "report-002",
    name: "FY2025 Sustainability",
    framework: "GRI",
    status: "in_progress",
    orgId: "org-2",
    reportYear: 2025,
    reportingPeriod: {
      start: "2025-01-01",
      end: "2025-12-31",
    },
  },
  {
    id: "report-003",
    name: "FY2024 ESG Report",
    framework: "BURSA",
    status: "completed",
    orgId: "org-1",
    reportYear: 2024,
    reportingPeriod: {
      start: "2024-01-01",
      end: "2024-12-31",
    },
  },
];

export const DASHBOARD_SUMMARY = {
  totalMetricsTracked: 20,
  metricsWithTargets: 16,
  metricsWithData: 14,
  metricsOnTrack: 10,
  metricsAtRisk: 4,
  metricsAhead: 2,
  overallCompletionRate: 75,
  overdueActions: 3,
  upcomingDeadlines: 5,
  lastDataUpdate: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
};

export const CATEGORY_PROGRESS = [
  {
    category: "Environment",
    total: 7,
    completed: 5,
    pending: 1,
    notStarted: 1,
    percentage: 71,
    onTrack: 4,
    atRisk: 2,
    overTarget: 1,
    color: "#10b981",
  },
  {
    category: "Social",
    total: 7,
    completed: 6,
    pending: 1,
    notStarted: 0,
    percentage: 86,
    onTrack: 5,
    atRisk: 1,
    overTarget: 1,
    color: "#3b82f6",
  },
  {
    category: "Governance",
    total: 6,
    completed: 4,
    pending: 2,
    notStarted: 0,
    percentage: 67,
    onTrack: 3,
    atRisk: 2,
    overTarget: 1,
    color: "#8b5cf6",
  },
];

export const METRICS_LIST = [
  {
    code: "E-01",
    title: "Energy Consumption",
    category: "Environment",
    progress: 78,
  },
  {
    code: "E-04",
    title: "GHG Emissions Intensity",
    category: "Environment",
    progress: 62,
  },
  {
    code: "S-02",
    title: "Employee Turnover",
    category: "Social",
    progress: 85,
  },
  {
    code: "S-05",
    title: "Training Hours",
    category: "Social",
    progress: 71,
  },
  {
    code: "G-01",
    title: "Board Independence",
    category: "Governance",
    progress: 90,
  },
  {
    code: "G-04",
    title: "Ethics & Compliance",
    category: "Governance",
    progress: 68,
  },
];

export const BENCHMARKING_DATA = [
  {
    metric: "Energy per Revenue",
    unit: "kWh/$M",
    "Your Company": 425,
    "First Philippine Holdings": 480,
    "Astra Group": 510,
  },
  {
    metric: "GHG per Employee",
    unit: "tCO2e/FTE",
    "Your Company": 2.4,
    "First Philippine Holdings": 2.8,
    "Astra Group": 3.1,
  },
  {
    metric: "Water per Revenue",
    unit: "m3/$M",
    "Your Company": 12.5,
    "First Philippine Holdings": 15.2,
    "Astra Group": 14.8,
  },
  {
    metric: "Safety Incidents",
    unit: "TRIFR",
    "Your Company": 1.8,
    "First Philippine Holdings": 2.2,
    "Astra Group": 2.5,
  },
  {
    metric: "Training Hours",
    unit: "hrs/employee",
    "Your Company": 42,
    "First Philippine Holdings": 38,
    "Astra Group": 35,
  },
  {
    metric: "Women in Leadership",
    unit: "%",
    "Your Company": 34,
    "First Philippine Holdings": 28,
    "Astra Group": 31,
  },
];

export const FRAMEWORK_COMPLETION = [
  {
    framework: "GRI",
    frameworkName: "Global Reporting Initiative",
    totalMetrics: 45,
    completedMetrics: 32,
    pendingMetrics: 10,
    notStartedMetrics: 3,
    completionPercentage: 71,
    lastUpdated: "2025-12-06T10:30:00Z",
    assignedTo: "ESG Team",
    dueDate: "2025-12-31",
  },
  {
    framework: "SGX",
    frameworkName: "Singapore Exchange",
    totalMetrics: 38,
    completedMetrics: 35,
    pendingMetrics: 3,
    notStartedMetrics: 0,
    completionPercentage: 92,
    lastUpdated: "2025-12-05T14:15:00Z",
    assignedTo: "Compliance Team",
    dueDate: "2025-12-15",
  },
  {
    framework: "BURSA",
    frameworkName: "Bursa Malaysia",
    totalMetrics: 42,
    completedMetrics: 28,
    pendingMetrics: 12,
    notStartedMetrics: 2,
    completionPercentage: 67,
    lastUpdated: "2025-12-04T09:45:00Z",
    assignedTo: "Sustainability Team",
    dueDate: "2025-12-31",
  },
  {
    framework: "TCFD",
    frameworkName: "Task Force on Climate-related Disclosures",
    totalMetrics: 28,
    completedMetrics: 18,
    pendingMetrics: 8,
    notStartedMetrics: 2,
    completionPercentage: 64,
    lastUpdated: "2025-12-03T16:20:00Z",
    assignedTo: "Climate Team",
    dueDate: "2026-01-15",
  },
  {
    framework: "SASB",
    frameworkName: "Sustainability Accounting Standards Board",
    totalMetrics: 35,
    completedMetrics: 30,
    pendingMetrics: 4,
    notStartedMetrics: 1,
    completionPercentage: 86,
    lastUpdated: "2025-12-06T11:00:00Z",
    assignedTo: "Finance & ESG Team",
    dueDate: "2025-12-20",
  },
];

export const getFrameworkCompletionSummary = () => {
  const totalMetrics = FRAMEWORK_COMPLETION.reduce(
    (sum, fw) => sum + fw.totalMetrics,
    0,
  );
  const completedMetrics = FRAMEWORK_COMPLETION.reduce(
    (sum, fw) => sum + fw.completedMetrics,
    0,
  );
  return {
    totalFrameworks: FRAMEWORK_COMPLETION.length,
    totalMetrics,
    completedMetrics,
    overallPercentage: Math.round((completedMetrics / totalMetrics) * 100),
  };
};
